import { configureStore } from "@reduxjs/toolkit";
import checkbox from './slice/checkboxSlice';
import userSlice from "./slice/userSlice";
import moduleFilterSlice from "./slice/moduleFilter";
import applicationSlice from "./slice/applicationSlice";
import subscriptionSlice from "./slice/subscriptionSlice";


export const store = configureStore({
  reducer: {
    checkbox,
    userSlice,
    moduleFilterSlice,
    applicationSlice,
    subscriptionSlice
  },
});
